import { useState, useEffect } from 'react';
import { X, Sparkles, Target, Palette } from 'lucide-react';

function WelcomeTip() {
  const [showTip, setShowTip] = useState(false);

  useEffect(() => {
    // Check if user has seen the welcome tip
    const hasSeenTip = localStorage.getItem('hasSeenWelcomeTip');
    if (!hasSeenTip) {
      // Show tip after a short delay
      setTimeout(() => setShowTip(true), 1500);
    }
  }, []);

  const handleDismiss = () => {
    setShowTip(false);
    localStorage.setItem('hasSeenWelcomeTip', 'true');
  };

  if (!showTip) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
      <div 
        className="bg-white rounded-2xl shadow-2xl max-w-lg w-full p-8 animate-fadeIn"
        data-testid="welcome-tooltip"
      >
        <div className="flex items-start justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="bg-[#E07A5F] rounded-full p-3">
              <Sparkles className="w-6 h-6 text-white" />
            </div>
            <h2 
              className="text-2xl font-medium text-stone-900"
              style={{ fontFamily: 'Manrope, sans-serif' }}
            >
              Welcome to Procrastination Popper!
            </h2>
          </div>
          <button
            onClick={handleDismiss}
            className="p-1 hover:bg-stone-100 rounded transition-colors"
            data-testid="dismiss-welcome-tip"
          >
            <X className="w-5 h-5 text-stone-400" />
          </button>
        </div>

        {/* Hero Image */}
        <div className="mb-6 flex justify-center">
          <img 
            src="https://customer-assets.emergentagent.com/job_task-breakdown-17/artifacts/5zfqf2rd_4_20260405_101800_0003.png"
            alt="Analysis Paralysis"
            className="w-40 h-40 object-contain"
            style={{ filter: 'drop-shadow(0 4px 6px rgba(0,0,0,0.1))' }}
          />
        </div>

        <div className="space-y-4 mb-6">
          <div className="flex items-start gap-3">
            <Sparkles className="w-5 h-5 text-[#E07A5F] flex-shrink-0 mt-1" />
            <div>
              <h3 
                className="font-medium text-stone-900 mb-1"
                style={{ fontFamily: 'Manrope, sans-serif' }}
              >
                Try AI Breakdown
              </h3>
              <p 
                className="text-sm text-stone-600"
                style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}
              >
                Type any task and click "AI Breakdown" to automatically split it into categories and steps.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <Target className="w-5 h-5 text-[#E07A5F] flex-shrink-0 mt-1" />
            <div>
              <h3 
                className="font-medium text-stone-900 mb-1"
                style={{ fontFamily: 'Manrope, sans-serif' }}
              >
                Focus with Pomodoro
              </h3>
              <p 
                className="text-sm text-stone-600"
                style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}
              >
                Use the timer to work in focused bursts. Choose your duration (15-90 min) and add background music.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <Palette className="w-5 h-5 text-[#E07A5F] flex-shrink-0 mt-1" />
            <div>
              <h3 
                className="font-medium text-stone-900 mb-1"
                style={{ fontFamily: 'Manrope, sans-serif' }}
              >
                Match Your Mood
              </h3>
              <p 
                className="text-sm text-stone-600"
                style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}
              >
                Click the palette icon in the header to switch themes. Try "Dread Mode" for tough tasks!
              </p>
            </div>
          </div>
        </div>

        <button
          onClick={handleDismiss}
          className="w-full bg-[#E07A5F] hover:bg-[#D46B4E] text-white py-3 rounded-lg font-medium transition-colors"
          style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}
        >
          Let's Go! 🚀
        </button>
      </div>
    </div>
  );
}

export default WelcomeTip;
